export const RUNTIME_HEALTH_SEVERITY = {
    error: "error",
    warn: "warn",
};
